import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getArchiveFolders } from '../api';

const GalleryArchiveList = () => {
  const [folders, setFolders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getArchiveFolders()
      .then(data => {
        setFolders(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="loading-spinner">Загрузка...</div>;

  return (
    <div className="container archive-list-page">
      <h1 className="section-title">Архивные папки</h1>
      {folders.length === 0 && <p>Нет архивных папок</p>}
      <div className="archive-folders-grid">
        {folders.map(folder => (
          <Link key={folder.id} to={`/gallery/archive/${folder.name}`} className="archive-folder-card">
            <div className="folder-icon">📁</div>
            <h3>{folder.name}</h3>
            <span>Посмотреть →</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default GalleryArchiveList;